import { actionCopyEs } from "./actionCopy";

export const analyticsCopyEs = {
    navTitle: "Análisis",
    navDescription: "Analice los datos de sus pacientes",
    events: "Eventos",
    outcomes: "Resultados",
    rawData: "Datos brutos",
    searchPatientsPlaceholder: "Buscar pacientes...",
    searchPatientsAria: "Buscar pacientes por nombre u otros campos",
    clearPatientSearchAria: "Borrar la búsqueda de pacientes",
    editWithAiPlaceholder: "Modificar con la IA",
    editWithAiAria: "Modificar con la IA",
    stopAiEditAria: "Detener la IA",
    downloadCsv: "Descargar el CSV",
    preparingCsv: "Preparando el CSV...",
    columns: actionCopyEs.columns,
    columnVisibilityDiffers: "La visibilidad de las columnas difiere del valor predeterminado",
    filter: actionCopyEs.filter,
    addFilter: "Añadir filtro",
    filtersFor: (name: string) => `Filtros para « ${name} »`,
    activeFilters: (count: number) => `${count} filtro${count === 1 ? " activo" : "s activos"}`,
    edit: actionCopyEs.edit,
    done: actionCopyEs.done,
    shared: "Compartido",
    noData: "Ningún dato",
    noScoresForFilter: "Ninguna puntuación para esta combinación de filtros",
    failedToLoadEvents: "No se han podido cargar los eventos",
    noEvents: "Ningún evento",
    patients: "Pacientes",
    gender: "Sexo",
    age: "Edad",
    area: "Área",
    diaryId: "ID del diario",
    patient: "Paciente",
    date: "Fecha",
    optionsFor: (name: string) => `Opciones para ${name}`,
    shiftLeft: "Mover a la izquierda",
    pieChart: "Gráfico circular",
    donutChart: "Gráfico de anillo",
    barChart: "Gráfico de barras",
    lineChart: "Gráfico de líneas",
    sparkCharts: "Gráficos sparkline",
    statsTable: "Tabla estadística",
    statsTableSpark: "Tabla estadística + sparkline",
    table: "Tabla",
    stats: "Estadísticas",
    timepointTable: "Tabla por plazo",
    histogram: "Histograma",
    changeFromBaseline: "Variación respecto a la inclusión",
    cumulativeEnrolment: "Inclusiones acumuladas",
    engagementRate: "Cumplimiento entre quienes han empezado",
    followUpCompletion: "Cumplimiento del seguimiento",
    engagementHint:
        "Proporción de diarios iniciados que han completado cada seguimiento. El valor inicial es el primer cuestionario, así que debe situarse cerca de la tasa de inicio del diario. Un cierre tardío cuenta igualmente como completado. Los diarios que nunca se iniciaron quedan fuera, y también las ventanas todavía abiertas.",
    engagementPercentCompleted: "Porcentaje completado",
    engagementRateHint:
        "De los pacientes que han empezado el cuestionario: completado en el plazo de un mes, solo algunas preguntas en el plazo de un mes, o no terminado en el plazo de un mes. Los pacientes que nunca han empezado no se incluyen.",
    engagementComplete: "A tiempo",
    engagementPartial: "Parcial en el plazo de 1 mes",
    engagementNotStarted: "No iniciado",
    engagementNotWithin: "No en el plazo de 1 mes",
    engagementDue: "Previsto",
    engagementStarted: "Iniciado",
    engagementOfPatientsDue: "Porcentaje de pacientes con seguimiento previsto",
    engagementOfPatientsStarted: "Porcentaje de pacientes que han empezado",
    engagementOfDue: (completed: number, due: number) => `${completed} de ${due} previstos`,
    engagementLate: "Con retraso",
    engagementMissed: "Omitido",
    engagementCompletion: "Cumplimiento",
    engagementAllPatients: "Todos los pacientes",
    engagementPatientsDue: (n: number) => `${n} previstos`,
    engagementHeatmapSplitHint:
        'Elija "Split by" en los ajustes del gráfico para comparar centros, etiquetas o clínicos.',
    engagementDotSize: "El tamaño del punto indica cuántos pacientes tenían un seguimiento previsto.",
    engagementDispositionHint:
        "Cada paciente cuenta una vez por ventana clínica. Los seguimientos abiertos quedan fuera hasta que se completan o hasta que se cierra la ventana permitida.",
    engagementTimingHint:
        "Días entre el envío y el momento previsto. El punto es la diferencia mediana y la barra es el 50 % central.",
    engagementTimingRangeHint:
        "El cero es el momento previsto. Un número positivo son días de retraso y un número negativo son días de adelanto. A tiempo significa dentro de la ventana permitida a ambos lados de ese momento: el intervalo hasta el siguiente seguimiento, de 1 día hasta 21 días.",
    engagementOnTimeCount: (onTime: number, completed: number) => `${onTime} de ${completed} a tiempo`,
    engagementTimingWindowColumn: "Ventana permitida",
    engagementDayWindow: (min: number, max: number) =>
        min === max ? `Ventana de ${min} días` : `Ventana de ${min} a ${max} días`,
    engagementTimingWindowSummary: (min: number, max: number) =>
        min === max ? `Dentro de una ventana de ${min} días` : `Dentro de una ventana de ${min} a ${max} días`,
    engagementWithinWindowCount: (onTime: number, completed: number, min: number, max: number) =>
        min === max
            ? `${onTime} de ${completed} dentro de una ventana de ${min} días`
            : `${onTime} de ${completed} dentro de una ventana de ${min} a ${max} días`,
    engagementOutsideDayWindow: (n: number, min: number, max: number) =>
        min === max ? `${n} fuera de la ventana de ${min} días` : `${n} fuera de la ventana de ${min} a ${max} días`,
    engagementOutsideWindow: (n: number, window?: string) =>
        window ? `${n} fuera de la ventana (${window})` : `${n} fuera de la ventana`,
    engagementWindowDays: (min: number, max: number) =>
        min === max ? `±${min} ${min === 1 ? "día" : "días"}` : `±${min} a ${max} días`,
    engagementOutsideWindowColumn: "Fuera de la ventana",
    engagementGapDays: (days: number) => {
        const rounded = Math.round(days * 10) / 10;
        const unit = Math.abs(rounded) === 1 ? "día" : "días";
        if (rounded === 0) return `0 ${unit}`;
        return `${rounded > 0 ? "+" : ""}${rounded} ${unit}`;
    },
    engagementTimingAxisDays: (days: number) => {
        if (days === 0) return "0";
        const unit = Math.abs(days) === 1 ? "día" : "días";
        return `${days > 0 ? "+" : ""}${days} ${unit}`;
    },
    engagementTimingEmpty: "Ningún seguimiento programado y completado tiene datos de tiempo",
    engagementEarlier: "Antes",
    engagementScheduled: "Programado",
    engagementLater: "Después",
    engagementMedian: "Mediana",
    engagementCompleted: "Completado",
    engagementMiddle50: "50 % central",
    engagementCompletedCount: (n: number) => `${n} completados`,
    engagementMetrics: "Indicadores de participación",
    engagementMetricsHint:
        "El cumplimiento de los registros y de los diarios usa los cuestionarios de los pacientes en diarios ya iniciados. El recuento de diarios completados se calcula sobre esos diarios iniciados. Los cuestionarios del clínico quedan fuera.",
    engagementMetric: "Indicador",
    engagementRateColumn: "Tasa",
    engagementCount: "Recuento",
    engagementOnTimeRate: "Tasa a tiempo",
    engagementDiaryStartRate: "Tasa de inicio del diario",
    engagementEntryCompletionRate: "Tasa de cumplimiento de los registros",
    engagementDiaryCompletionRate: "Tasa de cumplimiento del diario",
    engagementDiariesStarted: (completed: number, due: number) => `${completed} de ${due} diarios iniciados`,
    engagementEntriesCompleted: (completed: number, due: number) => `${completed} de ${due} registros completados`,
    engagementDiariesCompleted: (completed: number, due: number) => `${completed} de ${due} diarios completados`,
    engagementWindows: {
        baseline: "Valor inicial",
        w6: "Hasta 6 semanas",
        m3: "De 6 semanas a 3 meses",
        m6: "De 3 a 6 meses",
        m12: "De 6 a 12 meses",
        m12plus: "Más de 12 meses",
    } as Record<string, string>,
    engagementAllCompleted: "Todos completados",
    engagementSomeCompleted: "Algunos completados",
    engagementNoneStarted: "Todavía no se ha iniciado ningún seguimiento",
    engagementOnTime: "A tiempo",
    engagementUnderMonth: "Menos de 1 mes de retraso",
    engagementOverMonth: "Más de 1 mes de retraso",
    engagementEmpty: "Todavía no hay ningún seguimiento programado previsto",
    engagementPatient: "Paciente",
    engagementClinician: "Clínico",
    engagementCohort: "Cohorte",
    engagementByLabel: "Etiqueta del diario",
    engagementByClinician: "Clínico",
    engagementByTracker: "Cuestionario",
    engagementFollowUp: "Seguimiento",
    engagementFollowUpGrain: "Momento",
    engagementFollowUpAbsolute: "Absoluto",
    engagementFollowUpGrouped: "Agrupado",
    engagementFollowUpDaily: "Por día",
    engagementFollowUpWeekly: "Semanal",
    engagementFollowUpMonthly: "Mensual",
    engagementFollowUpQuarterly: "Trimestral",
    engagementFollowUpYearly: "Anual",
    engagementFollowUpDays: "Días",
    engagementFollowUpWeeks: "Semanas",
    engagementFollowUpMonths: "Meses",
    engagementFollowUpYears: "Años",
    engagementFollowUpAbsoluteHint: "Cada seguimiento permanece en su propio punto, en el orden del calendario.",
    engagementFollowUpGroupedHint: "Agrupado muestra Mes 0, Mes 1, Mes 2. El Mes 0 corresponde a los primeros 30 días.",
    engagementFollowUpStep: (grain: "day" | "week" | "month" | "quarter" | "year", index: number) => {
        const label =
            grain === "day"
                ? "Día"
                : grain === "week"
                  ? "Semana"
                  : grain === "month"
                    ? "Mes"
                    : grain === "quarter"
                      ? "Trimestre"
                      : "Año";
        return `${label} ${index}`;
    },
    engagementFollowUpGrainHint: (grain: "day" | "week" | "month" | "quarter" | "year") => {
        if (grain === "day") return "Por día muestra Día 0, Día 1, Día 2. El Día 0 es el día de la intervención.";
        if (grain === "week")
            return "Semanal muestra Semana 0, Semana 1, Semana 2. La Semana 0 corresponde a los primeros 7 días.";
        if (grain === "quarter")
            return "Trimestral muestra Trimestre 0, Trimestre 1, Trimestre 2. El Trimestre 0 corresponde a los primeros 90 días.";
        if (grain === "year") return "Anual muestra Año 0, Año 1, Año 2. El Año 0 es el primer año.";
        return "Mensual muestra Mes 0, Mes 1, Mes 2. El Mes 0 corresponde a los primeros 30 días.";
    },
    engagementGroupAria: "Desglose de la participación",
    engagementOf: (completed: number, due: number) => `${completed} de ${due}`,
    unlabelled: "Sin etiqueta",
    unassigned: "Sin asignar",
    timepoint: "Plazo",
    ageBracket: "Franja de edad",
    label: "Etiqueta del diario",
    sex: "Sexo",
    anatomicArea: "Área anatómica",
    event: "Evento",
    form: "Formulario",
    averageAge: "Edad media",
    patientCountsByAgeBracket: "Número de pacientes por franja de edad",
    ageDistribution: "Distribución por edad",
    chartOfGender: (chart: string) => `${chart} por sexo`,
    patientCountsByGender: "Número de pacientes por sexo",
    totalPatients: "Total de pacientes",
    meanField: (field: string) => `Media: ${field}`,
    formStats: (form: string) => `Estadísticas: ${form}`,
    tableOf: (dataset: string) => `Tabla: ${dataset}`,
    sparkChartsOf: (form: string) => `Gráficos sparkline: ${form}`,
    statsTableOf: (form: string) => `Tabla estadística: ${form}`,
    statsTableByTimepoint: (form: string) => `Tabla estadística por plazo: ${form}`,
    statsTableSparkOf: (form: string) => `Tabla estadística + sparkline: ${form}`,
    statsTableSparkByTimepoint: (form: string) => `Tabla estadística + sparkline por plazo: ${form}`,
    lineChartOverTime: (form: string) => `Gráfico de líneas de ${form} a lo largo del tiempo`,
    byTimepoint: (form: string) => `${form} por plazo`,
    histogramOf: (subject: string) => `Histograma: ${subject}`,
    previousTreatments: (form: string) => `Tratamientos anteriores · ${form}`,
    patientCountsBy: (group: string) => `Número de pacientes por ${group}`,
    barChartOfBy: (subject: string, group: string) => `Gráfico de barras: ${subject} por ${group}`,
    chartOf: (chart: string, subject: string) => `${chart}: ${subject}`,
    chartOfBy: (chart: string, dataset: string, field: string) => `${chart}: ${dataset} por ${field}`,
    bySuffix: (title: string, split: string) => `${title} por ${split}`,
    changeFromBaselineSubject: (subject: string) => `Variación respecto a la inclusión · ${subject}`,
    lsmeanChange: (subject: string) => `Variación de la media de mínimos cuadrados · ${subject}`,
    percentOfMax: (subject: string) => `% del máximo · ${subject}`,
    percentChangeFromBaseline: (subject: string) => `% de variación respecto a la inclusión · ${subject}`,
    score: "Puntuación",
    shiftRight: "Mover a la derecha",
    rename: actionCopyEs.rename,
    duplicate: actionCopyEs.duplicate,
    share: actionCopyEs.share,
    delete: actionCopyEs.delete,
    cancel: actionCopyEs.cancel,
    addView: "Añadir una vista",
    addViewDescription: "Elija primero un panel de gráficos o una hoja de datos brutos.",
    addViewStepOf: (step: number, total: number) => `Paso ${step} de ${total}`,
    addViewStepTypeTitle: "¿Qué tipo de vista?",
    addViewStepTypeDescription:
        "Elija un panel de gráficos o una hoja de datos brutos. Después podrá copiar los ajustes y consultar a la IA.",
    addViewStepSetupTitle: "Copiar ajustes o consultar a la IA",
    addViewStepSetupDescription: "Opcional. Copie los filtros de otra pestaña, describa lo que desea, o ambas cosas.",
    addViewBack: "Atrás",
    addViewAiLabel: "Preguntar a la IA",
    addViewAiPlaceholderCharts: "Opcional: describa los gráficos deseados, p. ej. WOMAC a lo largo del tiempo por edad",
    addViewAiPlaceholderData:
        "Opcional: describa los filtros, p. ej. diarios de rodilla de pacientes mayores de 60 años",
    copySettingsFrom: "Copiar los ajustes de",
    none: actionCopyEs.none,
    charts: "Gráficos",
    data: "Datos",
    chartsDescription: "Widgets, tendencias y estadísticas de resumen",
    dataDescription: "Hoja de cálculo de las filas de pacientes y de las puntuaciones",
    createChartsView: "Crear una vista de gráficos",
    createDataView: "Crear una vista de datos",
    refreshAria: "Actualizar los datos de análisis",
    addWidget: "Añadir un widget",
    addWidgetFor: (name: string) =>
        `Elija un formulario, un campo opcional y el modo de visualización para « ${name} ».`,
    noWidgetsOnTab: "Ningún widget en esta pestaña por el momento.",
    useAddWidgetToChart: (label: string) =>
        `Use « Añadir un widget » arriba para representar gráficamente datos reales ${label}.`,
    diaryFallback: "diario",
    failedToLoadAnalytics: "No se han podido cargar los datos de análisis",
    failedToLoadData: "No se han podido cargar los datos",
    failedToLoadPatientData: "No se han podido cargar los datos de los pacientes. Actualice para volver a intentarlo.",
    loadingPatients: "Cargando los pacientes...",
    loadingAnalytics: (label: string) => `Cargando los datos ${label}...`,
    analyticsFallback: "de análisis",
    fieldFallback: "Campo",
    noWidgetsYet: "Ningún widget por el momento. Añada uno desde la paleta o pídaselo al asistente de IA.",
    noWidgetsConfigured: "Ningún widget configurado para esta vista.",
    clearFilters: "Borrar los filtros",
    deleteViewTitle: "¿Eliminar la vista?",
    deleteViewDescription: (name: string) =>
        `Esta operación eliminará de forma definitiva « ${name} » y sus widgets. Esta acción es irreversible.`,
    showingRangeOf: (start: string, end: string, total: string, noun: string) =>
        `Visualización del ${start} al ${end} de ${total} ${noun}`,
    rowSingular: "fila",
    rowPlural: "filas",
    diarySingular: "diario",
    diaryPlural: "diarios",
    noPatientsMatch: (query: string) => `Ningún paciente coincide con « ${query} »`,
    noPatientsMatchFilters: "Ningún paciente coincide con los filtros actuales",
    searchColumnsPlaceholder: "Buscar columnas...",
    searchColumnsAria: "Buscar columnas",
    visibleColumns: "Columnas visibles",
    showAll: "Mostrar todo",
    hideAll: "Ocultar todo",
    eventsCount: "eventos",
    acrossDiaries: (count: number) => `En ${count} ${count === 1 ? "diario" : "diarios"}`,
    eventPrefix: (label: string) => `Evento · ${label}`,
    chartSettings: "Ajustes del gráfico",
    severalDataTabsHint:
        "Ya tiene varias pestañas de datos - considere modificar los filtros o las columnas de una pestaña existente.",
    chartN: (n: number) => `Gráfico ${n}`,
    dataN: (n: number) => `Datos ${n}`,
    showingColumnsOf: (visible: string, total: string) => `Visualización de ${visible} columnas de ${total}`,
    noColumnsMatch: (query: string) => `Ninguna columna coincide con « ${query} »`,
    filterCategories: {
        mine: "Mi rol",
        demographic: "Datos demográficos",
        label: "Etiqueta del diario",
        org: "Organización",
        form: "Formulario",
        event: "Evento",
        status: "Estado del diario",
    },
    filterAnnotations: {
        mine: "Diarios en los que tiene alguno de estos roles.",
        label: "Diarios con alguna de estas etiquetas.",
        org: "Diarios en alguna de estas organizaciones.",
        status: "Diarios con alguno de estos estados.",
    },
    filteredBy: "Filtrado por",
    sexValues: { Female: "Mujer", Male: "Hombre", Other: "Desconocido" },
    rawCellExplanations: {
        genderInferred:
            "El sexo se deduce del título que figura en el nombre del paciente (p. ej. Sr., Sra.). Modifique la columna Nombre para cambiarlo.",
        genderPrivate:
            "El sexo es una característica de cohorte deducida del título (p. ej. Sr., Sra.). El nombre permanece privado para su nivel de acceso.",
        patientNamePrivate: "El nombre del paciente es privado para su nivel de acceso.",
        patientNameHidden: "El nombre del paciente está oculto sin acceso a los datos identificativos.",
        dobPrivate: "La fecha de nacimiento es privada para su nivel de acceso.",
        ageEditable:
            "Edad en la fecha de inicio del diario, calculada a partir de la fecha de nacimiento - y no la edad actual del paciente. Modifique la fecha de nacimiento para cambiarla.",
        agePrivate:
            "Edad en la fecha de inicio del diario, calculada a partir de la fecha de nacimiento - y no la edad actual del paciente. La fecha de nacimiento permanece privada para su nivel de acceso.",
        ageReadonly:
            "Edad en la fecha de inicio del diario, calculada a partir de la fecha de nacimiento - y no la edad actual del paciente.",
        sideDerived:
            "El lado al que se refieren los cuestionarios de esta fila. Elija « Ambos » si están afectados ambos lados.",
        noQuestionnaireSide: "Ningún cuestionario en esta fila para el que definir un lado.",
        noEditableEvent: "Ningún evento modificable en este diario.",
        unsupportedEventValue: "Este valor no es compatible con el formulario de edición del evento.",
        productArea:
            "El área viene determinada por el producto seleccionado. Modifique la celda Producto para cambiarla.",
        noEventDate: "Ninguna fecha del evento que modificar en este diario.",
        noEditableArea: "Ningún evento modificable proporciona esta área.",
        shockwaveProcedure: "Las ondas de choque constituyen el tipo de intervención, no un detalle modificable.",
        noEditableProcedure: "Ningún evento modificable proporciona esta intervención.",
        ageDerived:
            "Edad en la fecha de inicio del diario, calculada a partir de la fecha de nacimiento. No es la edad actual del paciente.",
        durationDerived: "Calculada entre la fecha de inicio del diario y hoy.",
        ageAtEventDerived: (event: string) =>
            `Calculada a partir de la fecha de nacimiento y de la fecha más antigua de ${event}.`,
        noTracker: "Ningún seguimiento en este plazo para este diario.",
        noSideTracker: (side: string) => `Ningún seguimiento (${side}) en este plazo para este diario.`,
        notOnSchedule: "Este plazo no está presente en el calendario de este seguimiento.",
        notOnSideSchedule: (side: string) => `Este plazo no está presente en el calendario del seguimiento (${side}).`,
        multipleEventRows: (event: string) =>
            `Este evento (${event}) contiene varias filas de detalles. Modifíquelo desde el diario del paciente para no sustituir los demás detalles.`,
        multipleEvents: (event: string) =>
            `Varios eventos (${event}) contribuyen a esta celda. Modifíquelos desde el diario del paciente.`,
        multipleDates: (event: string) =>
            `Varias fechas (${event}) contribuyen a esta celda. Modifíquelas desde el diario del paciente.`,
        editDobHelper: "La edad al inicio del diario se calcula a partir de esta fecha de nacimiento.",
        editEventDateHelper: (event: string) => `Modificar la fecha (${event}).`,
    },
    eventDatasetLabels: {
        injection: "Inyecciones",
        surgery: "Cirugías",
        shockwave: "Ondas de choque",
        product: "Productos",
        education: "Consultas",
        medication: "Medicamentos",
    } as Record<string, string>,
    rawSideValues: { left: "izquierda", right: "derecha", both: "ambos", middle: "centro" } as Record<string, string>,
    showDetailsAria: "Mostrar los detalles",
    widgetTypes: {
        stat: "Tarjeta estadística",
        bar: "Barras",
        histogram: "Histograma",
        donut: "Anillo",
        pie: "Sectores",
        line: "Línea/área",
        spark: "Gráficos sparkline",
        statsTable: "Tabla estadística",
        statsTableSpark: "Tabla estadística + sparkline",
        timepoints: "Tabla por plazo",
        table: "Tabla",
        enrolment: "Inclusiones acumuladas",
        engagement: "Cumplimiento del seguimiento",
        engagementTable: "Tabla de seguimientos",
        engagementRate: "Entre quienes han empezado",
        engagementDisposition: "Situación del paciente",
        engagementTiming: "Momento respecto al calendario",
        engagementRetention: "Curva de permanencia",
        engagementKpi: "Cifras principales",
        engagementHeatmap: "Mapa de calor por división",
        engagementDots: "Gráfico de puntos",
    },
    valueTransforms: {
        absolute: "Absoluto",
        changeFromBaseline: "Variación respecto a la inclusión",
        lsmeanChange: "Variación de la media de mínimos cuadrados",
        percentOfMax: "% del máximo",
        percentChangeFromBaseline: "% de variación respecto a la inclusión",
    },
    summaryTable: {
        unknownForm: "Formulario desconocido",
        noEntries: "Ningún registro",
        metric: "Indicador",
        distribution: "Distribución",
        boxPlot: "Diagrama de caja",
        mean: "Media",
        median: "Mediana",
        mode: "Moda",
        sd: "DE",
        ci: "IC al 95%",
        frequency: "Frecuencia",
        value: "Valor",
        count: "Recuento",
        percent: "%",
        indicator: "Indicador",
        proportion: "Proporción",
        entries: "Registros",
        yes: "Sí",
        no: "No",
    },
    rawColumnGroups: {
        Patient: "PACIENTE",
        INJECTION: "INYECCIÓN",
        SURGERY: "CIRUGÍA",
        SHOCKWAVE: "ONDAS DE CHOQUE",
        PRODUCT: "PRODUCTO",
        CONSULTATION: "CONSULTA",
    } as Record<string, string>,
    rawFieldLabels: {
        Date: "Fecha",
        Substance: "Sustancia",
        Area: "Área",
        Site: "Localización",
        Side: "Lado",
        Dose: "Dosis",
        Type: "Tipo",
        Procedure: "Intervención",
        Product: "Producto",
        Topic: "Tema",
        "Provided by": "Facilitado por",
        "Delivered by": "Realizado por",
        "Referring clinician": "Médico que remite",
        "Injecting clinician": "Clínico que realiza la inyección",
        "Operating clinician": "Clínico que opera",
        "Shockwaving clinician": "Clínico que realiza las ondas de choque",
    } as Record<string, string>,
    rawColumnLabels: {
        diary_id: "ID del diario",
        patient_name: "Nombre",
        date_of_birth: "Fecha de nacimiento",
        age: "Edad",
        gender: "Sexo",
        organisation: "Organización",
        side: "Lado",
        area: "Área",
        procedure: "Intervención",
    } as Record<string, string>,
    scoreUnavailable: "No disponible",
    scoreAdd: "Añadir una puntuación",
    scoreNotDueYet: "Aún no corresponde",
    scoreLate: "Con retraso",
    scoreClickToAddTooltip: "Pulse la celda para añadir una puntuación",
    scoreLateTooltip: "Este plazo lleva retraso. Pulse la celda para añadir una puntuación.",
    scoreNotDueTooltip: "Este plazo aún no corresponde. Pulse la celda para añadir una puntuación.",
    scoreNoTrackerTooltip: "Ningún seguimiento en este plazo para este diario.",
    editScore: "Modificar la puntuación",
    decreaseScoreAria: "Disminuir la puntuación",
    increaseScoreAria: "Aumentar la puntuación",
    scoreRange: (min: number, max: number) => `Intervalo ${min} - ${max}`,
    scoreMin: (min: number) => `Mín ${min}`,
    scoreMax: (max: number) => `Máx ${max}`,
    confidential: "Confidencial",
    confidentialAria: "Datos del paciente confidenciales. Mostrar el motivo.",
    thisTimepoint: "Este plazo",
    dueDate: (date: string) => `Debe cumplimentarse el ${date}`,
    enteredDate: (date: string) => `Introducido el ${date}`,
    entryNotEnteredYet: "Aún no introducido",
    timepointHasRecordedScore: (point: string) => `${point} tiene una puntuación registrada.`,
    timepointDates: (point: string, dates: string) => `${point}: ${dates}.`,
    timepointNoTracker: (point: string) =>
        `${point} no tiene un seguimiento en este diario, por lo que no es posible añadir una puntuación.`,
    clickToAddScore: "Pulse para añadir una puntuación.",
};
